module.exports = __webpack_public_path__ + "static/work-static-52df8b72fed6f67f55681684c5ef805c.png";